export const getClientId = (): string => {
  let match = /(?:^|;)\s*_ga=([^;]*)/.exec(document.cookie);
  const raw = match ? decodeURIComponent(match[1]) : null;
  if (raw) {
    match = /(\d+\.\d+)$/.exec(raw);
  }
  return match ? match.input : "";
};
